<template>
  <v-stepper
    :value="step"
    class="elevation-0"
    style="background-color: var(--v-background-base)"
  >
    <v-stepper-header>
      <v-stepper-step
        color="blue darken-2"
        step="1"
        :complete="checkCompletedSteps(1)"
        >Create/Select Template</v-stepper-step
      >

      <v-divider></v-divider>

      <v-stepper-step
        color="blue darken-2"
        step="2"
        :complete="checkCompletedSteps(2)"
        >Add Products to your Template</v-stepper-step
      >

      <v-divider></v-divider>

      <v-stepper-step
        color="blue darken-2"
        step="3"
        :complete="checkCompletedSteps(3)"
        >{{ orderDateLabel }}</v-stepper-step
      >
    </v-stepper-header>
  </v-stepper>
</template>

<script>
export default {
  props: {
    step: null,
  },

  computed: {
    orderDateLabel() {
      // let label = "Choose a delivery date";

      // if (this.$store.getters.retrieveIsCncCustomer) {
      //   label = "Choose a collection date";
      // }

      let label = "Start Ordering!";

      return label;
    },
  },

  methods: {
    checkCompletedSteps(currentStep) {
      if (currentStep < this.step) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>